import { createSlice } from '@reduxjs/toolkit';

const initialState: string | undefined = '';

export const commercialLinkSlice = createSlice({
  name: 'commercialLink',
  initialState,
  reducers: {},
});

export const { reducer: commercialLinkReducer, name: commercialLinkReducerName } = commercialLinkSlice;
